import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$insuranceIdentifier/holdings")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello &ldquo;/dashboard/holdings&ldquo;!</div>;
}
